import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import AuthPageLayout from "../../components/layout/AuthPageLayout";
import { DEMO_PHONE_KEY } from "./DemoPhonePage";
import {
  TwoFactorContainer,
  TwoFactorIcon,
  TwoFactorTitle,
  TwoFactorSubtitle,
} from "../Auth/TwoFactorAuthPage/TwoFactorAuthPage.styled";
import images from "../../assets";

const DemoSuccessPage: React.FC = () => {
  const { t } = useTranslation();

  // Clean up demo session data on reaching success
  React.useEffect(() => {
    sessionStorage.removeItem(DEMO_PHONE_KEY);
  }, []);

  return (
    <AuthPageLayout withHeaderImage>
      <TwoFactorContainer>
        <TwoFactorIcon>
          <Box
            component="img"
            src={images.diamond}
            alt=""
            sx={{ width: "156px" }}
          />
        </TwoFactorIcon>

        <TwoFactorTitle>
          {t("demo.success.title", "Verification Successful")}
        </TwoFactorTitle>

        <TwoFactorSubtitle>
          {t(
            "demo.success.line1",
            "Your phone number has been successfully verified.",
          )}
        </TwoFactorSubtitle>

        <TwoFactorSubtitle sx={{ mt: -3 }}>
          {t(
            "demo.success.line2",
            "SMS-based authentication is working as expected.",
          )}
        </TwoFactorSubtitle>
      </TwoFactorContainer>
    </AuthPageLayout>
  );
};

export default DemoSuccessPage;
